// tslint:disable
import { ZendeskModel } from './zendesk.model';
import * as i0 from "@angular/core";
import * as i1 from "./zendesk.model";
function getWindow() {
    return window;
}
var ZendeskService = /** @class */ (function () {
    function ZendeskService(zendeskConfig) {
        var _this = this;
        if (!zendeskConfig.accountUrl) {
            throw new Error('Missing accountUrl. Please set in app config via ZendeskWidgetProvider');
        }
        this.window = getWindow();
        var window = this.window;
        // Following is essentially a copy paste of JS portion of the Zendesk embed code
        // with our settings subbed in. For more info, see:
        // https://support.zendesk.com/hc/en-us/articles/203908456-Using-Web-Widget-to-embed-customer-service-in-your-website
        window.zEmbed || function (e, t) {
            var n, o, d, i, s, a = [], r = document.createElement("iframe");
            window.zEmbed = function () {
                a.push(arguments);
            }, window.zE = window.zE || window.zEmbed,
                r.src = "javascript:false",
                r.title = "",
                r.style.cssText = "display: none",
                d = document.getElementsByTagName("script"),
                d = d[d.length - 1],
                d.parentNode.insertBefore(r, d),
                i = r.contentWindow,
                s = i.document;
            try {
                o = s;
            }
            catch (e) {
                n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);',
                    o = s;
            }
            o.open()._l = function () {
                var e = this.createElement("script");
                n && (this.domain = n),
                    e.id = "js-iframe-async",
                    e.src = "https://assets.zendesk.com/embeddable_framework/main.js",
                    this.t = +new Date,
                    this.zendeskHost = zendeskConfig.accountUrl,
                    this.zEQueue = a,
                    this.body.appendChild(e);
            },
                o.write('<body onload="document._l();">'),
                o.close();
        }();
        this.window.zE(function () {
            zendeskConfig.beforePageLoad(_this.window.zE);
        });
    }
    ZendeskService.prototype.setLocale = function (locale) {
        var _this = this;
        this.window.zE(function () {
            _this.window.zE.setLocale(locale);
        });
    };
    ZendeskService.prototype.identify = function (userObj) {
        var _this = this;
        this.window.zE(function () {
            _this.window.zE.identify(userObj);
        });
    };
    ZendeskService.prototype.hide = function () {
        var _this = this;
        this.window.zE(function () {
            _this.window.zE.hide();
        });
    };
    ZendeskService.prototype.show = function () {
        var _this = this;
        this.window.zE(function () {
            _this.window.zE.show();
        });
    };
    ZendeskService.prototype.activate = function (options) {
        var _this = this;
        this.window.zE(function () {
            _this.window.zE.activate(options);
        });
    };
    ZendeskService.prototype.setHelpCenterSuggestions = function (options) {
        var _this = this;
        this.window.zE(function () {
            _this.window.zE.setHelpCenterSuggestions(options);
        });
    };
    ZendeskService.prototype.setSettings = function (settings) {
        this.window.zESettings = settings;
    };
    ZendeskService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ZendeskService_Factory() { return new ZendeskService(i0.ɵɵinject(i1.ZendeskModel)); }, token: ZendeskService, providedIn: "root" });
    return ZendeskService;
}());
export { ZendeskService };
